module.exports = __webpack_public_path__ + "img/tddg-7.5153d132.webp";